<template>
  <div class="step-progress-bar local-hero">
    <div class="step-wrapper">
      <div class="step-number-text">
        {{stepInfo}}
      </div>
      <div class="step-description-text">
        {{description}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestStep',
  props: {
    stepInfo: {
      type: String,
    },
    description: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.step-progress-bar {
  display: flex;
  justify-content: center;

  .step-wrapper {
    @include tablet-and-up-screen {
      max-width: 70%;
    }
  }

  .step-number-text {
    font-size: 1.25rem;
    line-height: 1.75rem;

    @include desktop-screen {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  .step-description-text {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;

    @include tablet-screen {
      font-size: 2.25rem;
      line-height: 2.8rem;
    }

    @include desktop-screen {
      font-size: 3rem;
      line-height: 3.75rem;
    }
  }
}
</style>
